// extracted by mini-css-extract-plugin
export default {"controlVolumeCont":"control-volume_controlVolumeCont__3k3T3","header":"control-volume_header__Y3vfr"};